import React from 'react';
import { FaCircle, FaBuilding, FaCalendarAlt, FaChartBar, FaMoneyBillWave, FaTruck } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaCircle />,
  2: <FaBuilding />,
  3: <FaCalendarAlt />,
  4: <FaChartBar />,
  5: <FaMoneyBillWave />,
  6: <FaTruck />
};

const TireIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="tire"
      gradient="#4facfe 0%, #00f2fe 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default TireIndustryPage;

